import React, { useState } from 'react';
import { chakra, Icon } from '@chakra-ui/react';
import { PaymentSBP24Icon } from '@payler/ui-icons';
import { resolveApiAssetUrl } from '../../utils/resolveApiAssetUrl';

type DropdownIconComponent = React.FunctionComponent<
  React.SVGProps<SVGSVGElement>
>;

type ChakraSvgProps = React.SVGProps<SVGSVGElement> & {
  w?: number | string;
  h?: number | string;
};

const iconCache = new Map<string, DropdownIconComponent>();

function createImageIcon(src: string): DropdownIconComponent {
  const BankLogoIcon = React.forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement>
  >((props, ref) => {
    const [failed, setFailed] = useState(false);
    const { w, h, className, style } = props as ChakraSvgProps;

    if (failed) {
      return (
        <Icon
          as={PaymentSBP24Icon}
          ref={ref}
          color="brands.500"
          w={w}
          h={h}
          className={className}
          style={style}
        />
      );
    }

    return (
      <chakra.svg
        ref={ref}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        overflow="hidden"
        w={w}
        h={h}
        className={className}
        style={style}
      >
        <image
          href={src}
          width="24"
          height="24"
          preserveAspectRatio="xMidYMid meet"
          onError={() => setFailed(true)}
        />
      </chakra.svg>
    );
  });
  BankLogoIcon.displayName = 'BankLogoIcon';
  return BankLogoIcon as DropdownIconComponent;
}

export function getBankLogoIcon(
  logo: string | undefined,
  apiServer: string,
): DropdownIconComponent {
  if (!logo) {
    return PaymentSBP24Icon;
  }

  const src = resolveApiAssetUrl(apiServer, logo);
  if (!src) {
    return PaymentSBP24Icon;
  }

  if (!iconCache.has(src)) {
    iconCache.set(src, createImageIcon(src));
  }

  return iconCache.get(src)!;
}
